
import gn, { geom, math } from 'genart'

export default class Pelusa2 {
    constructor(x, y, radius, color, density=0.0001) {
      this.x = x;
      this.y = y;
      this.radius = radius;
      this.color = color;
      this.density = density;
    }

    draw_grad(){
      // Create radial gradient
      let ctx = p5App.drawingContext;
      p5App.push();
      p5App.noStroke();
      p5App.fill("#ff0000");

      let gradient = ctx.createRadialGradient( this.x, this.y, 1, this.x, this.y, this.radius );

      // Add three color stops
      gradient.addColorStop(0.2, this.color+"20");
      gradient.addColorStop(1, this.color+"00");

      // Set the fill style and draw a rectangle
      ctx.fillStyle = gradient;
      p5App.circle( this.x, this.y, this.radius*2 );

      for(let i=1; i<30; i++){
        let R = 1+this.radius/i;
        let pos = gn.geom.randomPointInCircle( R, this.x, this.y );
        gradient = ctx.createRadialGradient( pos.x, pos.y, 1, pos.x, pos.y, R );

        // Add three color stops
        gradient.addColorStop(0.2, this.color+"10");
        gradient.addColorStop(1, this.color+"00");

        // Set the fill style and draw a rectangle
        ctx.fillStyle = gradient;
        p5App.circle( pos.x, pos.y, R );
      }

      p5App.pop();

    }
  
    draw(){
      p5App.push()
      p5App.strokeWeight(1);
      p5App.stroke(this.color);
      //p5App.stroke("#0000fff0");
      p5App.beginShape(p5App.LINES)
      
      let countLines = 0;
      let n = 5;
      let rStep = 30;
      for (let i = 0; i < n; i++) {     
        let r = this.radius - (i*rStep); 
        let starts = gn.geom.randomPointsInCircle( r, this.x, this.y, (Math.PI*r*r)*this.density );
        let ends = gn.geom.randomPointsInCircle( r, this.x, this.y, (Math.PI*r*r)*this.density );
        starts.forEach( (p0, index) => {
          let p1 = ends[index]
          p5App.vertex( p0.x, p0.y )
          p5App.vertex( p1.x, p1.y )
          countLines++;
        });
      }
      p5App.endShape()
      p5App.pop();
    }
  }